import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorMode,
} from "@chakra-ui/react";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { UnifiedLoginModal } from "./components/UnifiedLoginModal";
import { getColor } from "../../brandConfig";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect } from "react";
import { usePageTitle } from "../../hooks/useDocumentTitle";

const LoginPage = () => {
  usePageTitle("Login");
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const bg = getColor("background.main", colorMode);
  const textPrimary = getColor(
    colorMode === "light" ? "text.primary" : "text.primaryDark",
    colorMode
  );
  const textMuted = getColor(
    colorMode === "light" ? "text.muted" : "text.mutedDark",
    colorMode
  );

  // If already logged in, redirect to home
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = () => {
    window.location.href = "/";
  };

  return (
    <Box
      bg={bg}
      minHeight="100vh"
      display="flex"
      flexDirection="column"
    >
      <NavbarWithCallToAction />

      <Container
        maxW="500px"
        flex="1"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={20}
      >
        <VStack spacing={6} textAlign="center">
          <Heading size="lg" color={textPrimary}>
            Welcome Back
          </Heading>
          <Text color={textMuted} fontSize="md">
            Log in to access your account.
          </Text>
        </VStack>
      </Container>

      <FooterWithFourColumns />

      <UnifiedLoginModal
        isOpen={true}
        onClose={() => navigate("/")}
        onLoginSuccess={handleLoginSuccess}
      />
    </Box>
  );
};

export default LoginPage;
